import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';

type SortingColumnTitleProps = {
  column_key: string;
  column_name: string;
};

type SortStatus = "ASCENDING" | "DESCENDING" | "OFF"

export const SortingColumnTitle = ({ column_key, column_name }: SortingColumnTitleProps) => {
const location = useLocation();
  const params = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const [sortStatus, setSortStatus] = useState<SortStatus>("OFF");

  function updateURLSort(value : string) {
    params.set("sort", encodeURIComponent(value))
    navigate({
      pathname: location.pathname,
      search: params.toString(),
    });
  }
  function removeURLSort() {
    params.delete("sort");
    navigate({
      pathname: location.pathname,
      search: params.toString(),
    });
  }

  function getURLSort() : string | null{
    return decodeURIComponent(params.get("sort") ?? "");
  }

  function hasURLSort() : boolean {
    return params.has("sort")
  }

  function toggleFilter(): void {
    switch (sortStatus) {
      case 'ASCENDING': updateURLSort("des_" + column_key); break;
      case 'DESCENDING': removeURLSort(); break;
      case 'OFF': updateURLSort("asc_" + column_key); break;
    }
  }

  function deriveStatusFromString(sort_setting : string): SortStatus {
    if (sort_setting == "asc_" + column_key) return "ASCENDING"
    else if (sort_setting == "des_" + column_key) return "DESCENDING"
    else return "OFF"
  }

  useEffect(() => {
      if (hasURLSort()) {
        const param = getURLSort()!;
        setSortStatus(deriveStatusFromString(param));
      } else {
        setSortStatus("OFF")
      }
    }, [location.search]);

  const icon = (() => {
    switch (sortStatus) {
      case 'ASCENDING': return <SouthIcon fontSize='small'/>
      case 'DESCENDING': return <NorthIcon fontSize='small'/>
      default: return <NorthIcon fontSize='small' sx={{visibility: 'hidden'}}/>
    }
  })()

  return (
    <button
      type="button"
      onClick={toggleFilter}
      style={{
        all: "unset",
        cursor: "pointer",
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '10px'
      }}
    >
      {column_name} {icon}
    </button>
  );
}